﻿import angular from "angular";

import "../../../services/cart";
import "../../../services/countries";
import "../../../services/user";
import * as dawaAutocomplete from "dawa-autocomplete2";

angular.module("folkeuni").component("customerInfo", {
  templateUrl: "/shop-dist/templates/customer-info.html?c=" + window.cacheBurst,
  bindings: {
    cart: "<",
    state: "<",
  },
  transclude: true,
  controller: function (
    Cart,
    Countries,
    User,
    $scope,
    $location,
    $element,
    $timeout
  ) {
    var $ctrl = this;
    $ctrl.postalCodeMax = 4;
    $ctrl.suggestions = {
      customer: {},
      company: {},
    };
    var defaultObj = {
      customer: {},
      company: {},
    };
    $ctrl.countryChange = function () {
      if ($ctrl.cart.checkout.customer.countryObj) {
        if ($ctrl.cart.checkout.customer.countryObj.code == "DK") {
          $ctrl.postalCodeMax = 4;
        } else {
          $ctrl.postalCodeMax = 6;
        }
      } else {
        $ctrl.postalCodeMax = 6;
      }
    };

    $ctrl.suggestionsCustomerPostalCodesSelectedIndex = 0;

    $ctrl.countries = [];

    $ctrl.paymentMethods = [
      {
        value: "Invoice",
        label: "Faktura",
      },
      {
        value: "Card",
        label: "Med kort",
      },
    ];

    $ctrl.$onInit = function () {
      $ctrl.countries = Countries.getAll;
      $ctrl.cart.checkout = $ctrl.cart.checkout
        ? $ctrl.cart.checkout
        : defaultObj;

      User.getCurrent().then(
        function (userObj) {
          userObj.phoneNumber = Number(userObj.phoneNumber);

          for (var i in $ctrl.countries) {
            var currentCountry = $ctrl.countries[i];

            if (
              userObj.country.indexOf(":") > 0 &&
              currentCountry.code == userObj.country.split(":")[0]
            ) {
              userObj.countryObj = currentCountry;
              userObj.country = currentCountry.code;
              break;
            } else if (
              userObj.country &&
              userObj.country == currentCountry.code
            ) {
              userObj.countryObj = currentCountry;
              break;
            }
          }
          $ctrl.cart.checkout.customer = userObj;
          $ctrl.cart.checkout.customer.confirmEmail = userObj.email;
          $ctrl.cart.checkout.customer.isLoggedIn = true;
        },
        function (error) {}
      );

      $ctrl.countryChange();

      $ctrl.cart.checkout.customer.createUser = false;

      $timeout(function () {
        var streetnameInput = $element[0].querySelector(
          'input[ng-model="$ctrl.cart.checkout.customer.streetName"]'
        );
        if (streetnameInput) {
          dawaAutocomplete.dawaAutocomplete(
            streetnameInput,
            {
              select: function (selected) {
                $scope.$apply(function () {
                  $scope.$ctrl.cart.checkout.customer.streetNumber = selected.data.husnr;
                  $timeout(function () {
                      $scope.$ctrl.cart.checkout.customer.streetName = selected.data.vejnavn;
                  }, 100);
                  $scope.$ctrl.cart.checkout.customer.postalCode = Number(
                    selected.data.postnr
                  );
                  $scope.$ctrl.cart.checkout.customer.city = selected.data.postnrnavn;
                  $scope.$ctrl.cart.checkout.customer.floorNumber = selected.data.etage;
                  if (
                    selected.data.dør != null &&
                    !isNaN(Number(selected.data.dør))
                  ) {
                    $ctrl.cart.checkout.customer.roomNumber = selected.data.dør != undefined ? selected.data.dør.toString() : "";
                    $ctrl.cart.checkout.customer.side = "";
                  } else {
                    $ctrl.cart.checkout.customer.side = selected.data.dør != undefined && selected.data.dør != null ? selected.data.dør.toString() : "";
                    $ctrl.cart.checkout.customer.roomNumber = "";
                  }

                  $timeout(function () {
                    streetnameInput.value = $scope.$ctrl.cart.checkout.customer.streetName;
                  }, 150);
                });
              },
            }
          );
        } else {
          console.error("Streetname input not found.");
        }
      }, 0);
    };

    $ctrl.compareEmails = function ($event) {
      var input = $event.target;
      if (input.value != $ctrl.cart.checkout.customer.email) {
        input.setCustomValidity("Bekræft venligst din email");
        input.classList.add("ng-invalid");
      } else {
        input.setCustomValidity("");
        input.classList.remove("ng-invalid");
      }
    };

    $ctrl.back = function () {
      var hasStudendDiscount = Cart.hasStudentTickets($ctrl.cart);

      if (hasStudendDiscount) {
        $location.path("discounts");
      } else {
        $location.path("cart");
      }
    };

    $ctrl.next = function () {
      if ($scope.form.customerInfo.$valid) {
        var valid = true;

        if (
          $ctrl.cart.checkout.customer.createUser &&
          $ctrl.cart.checkout.customer.password !=
            $ctrl.cart.checkout.customer.confirmPassword
        ) {
          $ctrl.cart.checkout.errorMessage =
            "Det indtastede password er ikke ens.";
          valid = false;
        }

        if ($ctrl.cart.checkout.business) {
          if (!$ctrl.cart.checkout.company.paymentType) {
            valid = false;
            $ctrl.cart.checkout.errorMessage = "Du skal vælge betalingsmetode.";
          }
        } else {
          $ctrl.cart.checkout.company = null;
        }

        if (valid) {
          $ctrl.cart.checkout.keyAccount = [];
          for (var i in $ctrl.cart.keyAccountFields) {
            var currentField = $ctrl.cart.keyAccountFields[i];

            $ctrl.cart.checkout.keyAccount.push(currentField);
          }

          $ctrl.cart.checkout.customer.country =
            $ctrl.cart.checkout.customer.countryObj.code;
          $ctrl.cart.checkout.errorMessage = null;

          Cart.customerInfoLocalStorageSet($ctrl.cart.checkout);
          $location.path("confirm");
        }
      } else {
      }
    };
  },
});
